import { GetPurchasePromosResponse } from '@weave/schema-gen-ts/dist/schemas/payments-platform/care-credit-integration/care_credit_integration.pb';
import { CareCreditIntegrationV1 } from '@frontend/api-care-credit-integration';
import { FinanceOption } from '../types/care-credit.types';
import { getFinanceOptionType, stripHtmlTags } from '../widgets/care-credit-collect-multi-step/utils/financing-options';

export type UseCareCreditFinanceOptionsProps = {
  amount: number;
  personId?: string;
  locationId?: string;
  merchantNumber?: string;
  accountId?: string;
};
export const useCareCreditFinanceOptions = ({
  personId,
  locationId,
  amount,
  merchantNumber,
  accountId,
}: UseCareCreditFinanceOptionsProps) => {
  const { data, ...query } = CareCreditIntegrationV1.Queries.useGetPurchasePromosQuery({
    request: {
      personId: personId || '',
      merchantNumber: merchantNumber || '',
      amount,
      accountId,
    },
    options: {
      enabled: (!!personId || !!accountId) && (!!locationId || !!merchantNumber) && amount > 0,
    },
  });

  const financeOptions = parseResponseToFinanceOptions(data);

  return { ...query, financeOptions };
};

const ALLOWED_PROGRAM_NAMES = ['CareCredit'] as const;

function parseResponseToFinanceOptions(data: GetPurchasePromosResponse | undefined): FinanceOption[] {
  if (!data) {
    return [];
  }

  const financeOptions: FinanceOption[] = [];

  data.data?.programs?.forEach((program) => {
    if (ALLOWED_PROGRAM_NAMES.includes(program.programName as (typeof ALLOWED_PROGRAM_NAMES)[number])) {
      program.promos?.forEach((promo) => {
        const title = stripHtmlTags(promo.title || '');

        financeOptions.push({
          id: promo.id || '',
          title,
          requiredPayment: Number(promo.estimatedMonthlyPayment) || 0,
          promoCode: promo.code || '',
          period: Number(promo.introMonths) || 0,
          description: promo.description || '',
          interestRate: Number(promo.cardholderInterestRate),
          totalAmount: Number(promo.totalAmount),
          minAmount: Number(promo.minPurchaseAmount),
          type: getFinanceOptionType(promo),
        });
      });
    }
  });

  return financeOptions;
}
